export const caretDown = `
<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 6L10 1.14343L8.82446 0L5 3.71717L1.17637 0L0 1.14263L5 6Z" fill="white"/>
</svg>

`
